import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BaseModalComponent } from '@ui/modal/base-modal.component';
import { ModalComponent } from '@ui/modal/modal.component';

@Component({
  selector: 'app-video-modal',
  imports: [ModalComponent, TranslatePipe],
  templateUrl: './video-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoModalComponent extends BaseModalComponent {}
